// extracted by mini-css-extract-plugin
module.exports = {"footer":"footer_footer__1CjGN","social":"footer_social__Y0Phc"};